import { makeStyles } from '@material-ui/styles'

export default makeStyles(() => ({
  modal: {
    minHeight: 250
  }
}))
